import { render, staticRenderFns } from "./TheUpsertInternationalLogistic.vue?vue&type=template&id=6919e8ca"
import script from "./TheUpsertInternationalLogistic.vue?vue&type=script&lang=ts"
export * from "./TheUpsertInternationalLogistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports